import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import { useEffect, useState } from "react";
import NoContentPage from "../../../../layout/dashboard/no-content/NoContentPage";

ChartJS.register(ArcElement, Tooltip, Legend);

const dataSet = {
  labels: ["Promoters", "Passives", "Detractors"],
  datasets: [
    {
      label: "NPS Score",
      data: [0, 0, 0],
      backgroundColor: [
        "rgba(0, 153, 51, 1)",
        "rgba(239, 191, 4, 1)",
        "rgba(247, 102, 89, 1)",
      ],
      borderWidth: 1,
      borderColor: [
        "rgba(0, 153, 51, 1)",
        "rgba(239, 191, 4, 1)",
        "rgba(247, 102, 89, 1)",
      ],
    },
  ],
};

const options: ChartOptions<"doughnut"> = {
  responsive: true,
  plugins: {
    legend: {
      display: false, // Hide the default legend
    },
    datalabels: {
      color: "#fff",
      formatter: (value: number) => `${value}%`, // Format the value
      font: {
        weight: "bold",
        size: 18,
      },
    },
    tooltip: {
      enabled: true, // Enable tooltips on hover
      callbacks: {
        label: function (context) {
          let label = context.label || "";
          if (label) {
            label += ": ";
          }
          if (context.parsed !== null) {
            label += context.parsed + "%";
          }
          return label;
        },
      },
    },
  },
};

export default function PercentageChart() {
  const [data, setData] = useState(dataSet);
  const { loading_metric, metric_chart } = useSelector(
    (state: RootState) => state.report
  ); // for report

  useEffect(() => {
    setData({
      labels: metric_chart?.nps_percentage_chart?.data?.map(
        (val: any) => val?.label
      ) || ["Promoters", "Passives", "Detractors"],
      datasets: [
        {
          label: "NPS Score",
          data: metric_chart?.nps_percentage_chart?.data?.map(
            (val: any) => val?.value
          ) || [0, 0, 0],
          backgroundColor: metric_chart?.nps_percentage_chart?.data?.map(
            (val: any) => val?.color
          ) || [
            "rgba(0, 153, 51, 1)",
            "rgba(239, 191, 4, 1)",
            "rgba(247, 102, 89, 1)",
          ],
          borderWidth: 1,
          borderColor: metric_chart?.nps_percentage_chart?.data?.map(
            (val: any) => val?.color
          ) || [
            "rgba(0, 153, 51, 1)",
            "rgba(239, 191, 4, 1)",
            "rgba(247, 102, 89, 1)",
          ],
        },
      ],
    });
  }, [metric_chart?.nps_percentage_chart]);

  return (
    <div className="min-h-[480px] rounded-[8px] bg-white p-[16px] col-span-4">
      <p className="text-center font-medium text-[14px] text-[#596080] mb-[20px]">
        NPS Percentage Chart
      </p>
      {loading_metric ? (
        <NoContentPage height="35rem" loading={true} />
      ) : (
        <Doughnut data={data} options={options} />
      )}

      <div className="text-[#758089] text-[12px] flex justify-between items-center mt-[26px]">
        <div className="inline-flex items-center gap-[4px]">
          <span className="size-[8px] rounded-[2px] bg-[#F76659] block" />
          <p>(0-4) Detractors</p>
        </div>
        <div className="inline-flex items-center gap-[4px]">
          <span className="size-[8px] rounded-[2px] bg-[#EFBF04] block" />
          <p>(5-7) Passives</p>
        </div>
        <div className="inline-flex items-center gap-[4px]">
          <span className="size-[8px] rounded-[2px] bg-[#009933] block" />
          <p>(8-10) Promoters</p>
        </div>
      </div>
    </div>
  );
}
